import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    role: null,
    permissions: null,
}

// Token here is access token
const permissions_slice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermissions: (state, action) => {
            state.permissions = action.payload
        }
    }
})

export const { setPermissions } = permissions_slice.actions;
export default permissions_slice.reducer;